import React from 'react'
import styled from 'styled-components'
import TextField, {StyledInput} from 'lib/ui/TextField'
import Switch from 'lib/ui/form/Switch'
import {onChangeCheckedHandler} from 'lib/dom'
import RemoveButton from 'lib/ui/form/RemoveButton'
import {SignUpAdditionalField} from 'Event/template'

export default function SignUpAdditionalFieldInput(props: {
  field: SignUpAdditionalField
  onChange: (field: SignUpAdditionalField) => void
  remove: () => void
}) {
  const {field, onChange, remove} = props

  const update = <K extends keyof SignUpAdditionalField>(key: K) => (
    value: SignUpAdditionalField[K],
  ) => {
    onChange({...field, [key]: value})
  }

  return (
    <Box>
      <RemoveButton onClick={remove} aria-label="remove additional field" />
      <Input>
        <TextField
          label="Group"
          fullWidth
          variant="outlined"
          inputProps={{'aria-label': 'additional field group'}}
          value={field.groupKey}
          onChange={update('groupKey')}
        />
      </Input>
      <Input>
        <TextField
          label="Label"
          fullWidth
          variant="outlined"
          inputProps={{'aria-label': 'additional field label'}}
          value={field.label ?? ''}
          onChange={update('label')}
        />
      </Input>
      <RequiredToggle>
        <Switch
          checked={field.isRequired}
          onChange={onChangeCheckedHandler(update('isRequired'))}
          aria-label="toggle additional field required"
          labelPlacement="end"
          label="Required"
        />
      </RequiredToggle>
    </Box>
  )
}

const Box = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const Input = styled.div`
  margin-right: ${(props) => props.theme.spacing[2]};
  overflow: hidden;

  ${StyledInput} {
    width: 100%;
  }
`

const RequiredToggle = styled.div`
  margin-left: ${(props) => props.theme.spacing[2]};
  white-space: nowrap;
`
